import { jsx as _jsx } from "react/jsx-runtime";
function Shapes({ className, size = 24 }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { d: "M5.95 10l5.452-9 5.454 9H5.949zM17.848 22c-2.739 0-4.958-2.239-4.958-5s2.22-5 4.957-5c2.738 0 4.958 2.239 4.958 5s-2.22 5-4.957 5zM1.983 13h7.932v8H1.983v-8z" }) }));
}
export default Shapes;
